import React from 'react';
import FileStorage from '../components/FileStorage';

const PitchDeck = () => {
  return (
    <FileStorage
      category="pitch-deck"
      title="Pitch Deck"
      description="Investment presentation materials and investor communication documents"
    />
  );
};

export default PitchDeck;